import { Color, ColorSemantic } from '@previo/codebooks'
import variables from '../../assets/scss/shared/_brand.module.scss'

type TUseColorComposable = {
  getHexByColor: (color: Color) => string
  getCssVarByColor: (color: Color | ColorSemantic) => string
}

export const useColor = (): TUseColorComposable => {
  const getHexByColor = (color: Color): string => {
    if (!variables[color]) {
      throw new Error(`Color "${color}" not found`)
    }

    return variables[color]
  }

  /**
   * CSS variable reference for inline styles. Resolved by the browser at paint
   * time, so it follows any semantic override applied via PrevioDesignSystem options.
   */
  const getCssVarByColor = (color: Color | ColorSemantic): string => `var(--color-${color})`

  return {
    getHexByColor,
    getCssVarByColor,
  }
}
